import { render, staticRenderFns } from "./Presence.vue?vue&type=template&id=09ec821c&"
import script from "./Presence.vue?vue&type=script&lang=ts&"
export * from "./Presence.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports